var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list"},[_c('i',{staticClass:"wz-icon wz-check-double text--black"}),_c('p',{staticClass:"text--grey--c"},[(_vm.title)?_c('strong',[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }